__turbopack_context__.v({
  "actionButton": "ShopFiltersDropdown-module-scss-module__3TkQMa__actionButton",
  "indicatorIndicator": "ShopFiltersDropdown-module-scss-module__3TkQMa__indicatorIndicator",
  "indicatorRoot": "ShopFiltersDropdown-module-scss-module__3TkQMa__indicatorRoot",
  "label": "ShopFiltersDropdown-module-scss-module__3TkQMa__label",
  "opened": "ShopFiltersDropdown-module-scss-module__3TkQMa__opened",
});
